export default __webpack_public_path__ + "static/media/_shares-icon_dark.9f5c93a2.svg";